export const PROFILE_IMAGE = "22712";
export const CV = "227234";
export const PUBLICATION_WEB_ANONYMOUS = "55479";
export const ACCEPTED = "94606";
export const REJECTED = "94607";
export const PENDING = "4280";
export const TEMPORARY = "19300";
